import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, MouseEvent } from 'react';

import { useCallContext } from '@gem/call/CallView/CallView.context';
import { CloseButton } from '@gem/call/CallView/Shared/CloseButton/CloseButton';
import { PermissionsTypes } from '@gem/call/Model/callPermissions/callPermissionsModel.types';
import { DotsIcon, IcClose32Icon, IcBackIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import {
  customScrollStyles,
  IconButton,
  IconViewSizes,
  PopoverMenu,
  usePopover,
} from '@gem/ui-kit';

import { useRequestedPermissionsPanelPresenter } from './RequestedPermissionsPanel.presenter';
import styles from './RequestedPermissionsPanel.styles.m.css';
import { RequestsPermissionsBlock } from './components/RequestsPermissionsBlock/RequestsPermissionsBlock';

export const RequestedPermissionsPanel: FC = observer(() => {
  const { t } = useTranslation();
  const { call, callController } = useCallContext();
  const popover = usePopover<HTMLButtonElement>();
  const presenter = useRequestedPermissionsPanelPresenter({ popover });

  const handleMenuClick = (event: MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation();
    event.preventDefault();

    popover.toggle();
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <IconButton
          className={styles.backIcon}
          size={IconViewSizes.Big}
          theme="11"
          Icon={IcBackIcon}
          onClick={presenter.onBack}
        />
        <div className={styles.content}>
          <div className={styles.title}>{t('call_permission_requests')}</div>
        </div>
        <>
          <IconButton
            setRef={popover.containerRef}
            Icon={DotsIcon}
            className={classNames(styles.menuButton, {
              [styles.menuButtonVisible]: popover.isOpened,
            })}
            size={IconViewSizes.Big}
            theme="11"
            isActive={popover.isOpened}
            onClick={handleMenuClick}
          />

          <PopoverMenu
            className={styles.menu}
            isOpened={popover.isOpened}
            menuItems={presenter.actions}
            onClose={popover.close}
            reference={popover.containerRef.current}
            placement="bottom-end"
            theme={'dark'}
          />
        </>
        <div>
          <CloseButton
            Icon={IcClose32Icon}
            onClick={presenter.onClose}
          />
        </div>
      </div>
      <div className={classNames(styles.memberListContainer, customScrollStyles.container)}>
        {Object.values(PermissionsTypes).map((type) => {
          return (
            !!presenter.permissionsRequests.get(type)?.length && (
              <RequestsPermissionsBlock
                key={type}
                permissionType={type}
                call={call}
                callController={callController}
              />
            )
          );
        })}
      </div>
    </div>
  );
});
